import styled from "@emotion/styled";
import { spacing } from "../design-tokens";

export const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing.lg}px;
  padding: 0;
  background: transparent;
  box-sizing: border-box;
  width: 100%;
`;

export const ActionsGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing.md}px;
  justify-content: flex-start;
  align-items: center;
`;
